import { Layout } from 'antd';
import './AppFooter.css'
import { List, Typography, Card } from 'antd';
const { Text, Link } = Typography;

const { Footer } = Layout;

export const AppFooter = () => {
    return (
        <Footer className={"Footer"}>
        This platform is part of a research project by the Max Planck Institute for Software Systems<br />
        Campus E1 5, 66123 Saarbrücken, Germany<br />
        <Link href="https://imprint.mpi-klsb.mpg.de/sws/social-media-data-donator.mpi-sws.org/" target="_blank">
                 Imprint
        </Link>
        /
        <Link href="https://data-protection.mpi-klsb.mpg.de/sws/social-media-data-donator.mpi-sws.org/" target="_blank">
                 Data Protection
        </Link>
        </Footer>
    )
}

export default AppFooter;